<template>
  <div>
    <v-app-bar elevate-on-scroll app color="red-darken-4">
      <v-toolbar-title aling="center" class="white--text">
        <v-img
          class="mx-auto"
          :width="160"
          cover
          src="/static/iconos/logowhite3.png"
        ></v-img>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-title class="white--text"
        ><b>{{ $route.meta.title }}</b></v-toolbar-title
      >
      <v-spacer />
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon>
            <v-icon color="white">mdi-bell</v-icon>
          </v-btn>
        </template>
        <span>Notificaciones</span>
      </v-tooltip>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            @click="
              changeTheme();
              changeicon = !changeicon;
            "
          >
            <v-icon color="white">{{
              changeicon == true ? "mdi-weather-night" : "mdi-weather-sunny"
            }}</v-icon>
          </v-btn>
        </template>
        <span>Tema de página</span>
      </v-tooltip>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" link to="/perfiles" icon>
            <v-icon color="white">mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <span>Cambio Perfil</span>
      </v-tooltip>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon>
            <v-icon color="white">mdi-progress-question</v-icon>
          </v-btn>
        </template>
        <span>Ayuda</span>
      </v-tooltip>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" @click="cerrar" icon>
            <v-icon color="white">mdi-power-standby</v-icon>
          </v-btn>
        </template>
        <span>Cerrar sesión</span>
      </v-tooltip>
    </v-app-bar>
    <menu_general :ChangeTheme.sync="changeicon"> </menu_general>
  </div>
</template>
<script>
import { useTheme } from "vuetify";
import menu from "./MenuGeneral.vue";
const isDark = localStorage.getItem("isDark");
var iconthem = false;
export default {
  name: "navegacion-menu",
  components: {
    menu_general: menu,
  },
  data() {
    return {
      changeicon: iconthem,
      messages: 0,
      nosend: false,
      interval: {},
      notificaciones: {
        titlenotific: "",
        textnotific: "",
        notificacionesview: false,
      },
      notificacionresult: [],
    };
  },
  methods: {
    // Si no activan la sesión se cierra el aplicativo
    cerrar() {
      this.$router.replace({ path: "/" });
      localStorage.removeItem("infouser");
      localStorage.removeItem("registromenu");
      localStorage.removeItem("infoperfil");
      localStorage.removeItem("paginainfo");
      localStorage.removeItem("token");
      this.axios.defaults.baseURL = "";
      this.axios.defaults.headers.common["Authorization"] = "";
      this.axios.defaults.timeout = 0;
    },
  },
  setup() {
    const theme = useTheme();
    theme.global.name.value = isDark == "1" ? "dark" : "light";
    iconthem = isDark == "1" ? true : false;
    return {
      theme,
      changeTheme: () => {
        theme.global.name.value = theme.global.current.value.dark ? "light" : "dark";
        localStorage.setItem("isDark", theme.global.name.value == "dark" ? "1" : "0");
      },
    };
  },
  mounted() {
    // Seguridad
    this.$store.commit("GetRoles");
    this.$store.commit("GetUsers");
    this.$store.commit("GetCargo");
    this.$store.commit("GetGroupUsers");
    this.$store.commit("GetDirectoryActive");
    this.$store.commit("GetSecurityPolitic");
    this.$store.commit("GetArea");
    this.$store.commit("GetCargo");
    // Documentos
    this.$store.commit("GetGrupoDocumentos");
    this.$store.commit("GetRuta");
    this.$store.commit("GetConversion");
    this.$store.commit("GetServidor");
    //Parametros
    this.$store.commit("GetTablaSeleccion");
    this.$store.commit("GetInfoPais");
    this.$store.commit("GetInfoZonaDepartamento");
    this.$store.commit("GetDpto");
    this.$store.commit("GetCity");
    this.$store.commit("GetLocalidad");
    this.$store.commit("GetUpz");
    this.$store.commit("GetDescSucursal");
    this.$store.commit("GetDescMoneda");
    this.$store.commit("GetCalendario");
    this.$store.commit("GetRisk");
    this.$store.commit("GetDescCiclo");
    this.$store.commit("GetCodigoAyuda");
    this.$store.commit("GetMessageError");
    this.$store.commit("GetPlantilla");
    // Procesos
    this.$store.commit("GetIntefaceData");
    this.$store.commit("GetLineas");
    this.$store.commit("GetProcesos");
    this.$store.commit("GetProcesosDelete");
    this.$store.commit("GetDatos");
    this.$store.commit("GetTablaNumerico");
    this.$store.commit("GetTablaAlfaNumerico");
    this.$store.commit("GetCausales");
    this.$store.commit("GetConstantes");
    // Activos
    this.$store.commit("GetInfoTiposActivos");
    this.$store.commit("GetInfoSubTiposActivos");
    this.$store.commit("GetFaseColda");
    this.$store.commit("GetColor");
    this.$store.commit("GetDescProducto");
    this.$store.commit("GetServicios");
    this.$store.commit("GetEstadoServicios");
    this.$store.commit("GetObservacionServicios");
    this.$store.commit("GetDocumentos");
    // Personas
    this.$store.commit("GetNotificaciones");
    // Reportes
    this.$store.commit("GetReportes");
  },
};
</script>
